import $ from 'jquery'
import _ from 'lodash'
import template from './metric-comparison-step2.hbs'
import Gardener from 'scoreboard/components/gardener'
import MultiTreeSelector from 'scoreboard/components/multi-tree-selector'
import i18n from 'scoreboard/components/i18n'
import constants from 'scoreboard/components/constants'

var MetricsView = MultiTreeSelector.extend({

	className: 'report-metric-comparison metric-comparison-step2 tree-selector-form ' +
		'single-tree-selector two-column-details-form ' + MultiTreeSelector.prototype.className,

	_template: function(ctx) {
		let scorecardItemText = i18n.get('scorecards.scorecardNode').toLowerCase()
		return template({ emptyMessage: i18n.get('report.metricComparisonReport.mustSelectOneItem.error', scorecardItemText) })
	},

	createGardener: function() {
		var data = this.model.get('orgAndScorecardRoot')
		let gardener = new Gardener({
			section: constants.SECTION_SCORECARDS,
			id: data.rootId,
			orgId: data.organizationId,
			forest: false,
			finderOptions: {
				type: 'light'
			}
		})
		gardener.forest = false // #20233
		return gardener
	},

	initialize: function(options) {
		this.includeDescendants = _.clone(this.oldSelections())
		if (options.filterType === 'compare-scorecards') {
			this.cascade = false
		}

		MultiTreeSelector.prototype.initialize.apply(this, arguments)

		//prune any invalid metrics that are currently set
		if (!_.isEmpty(this.includeDescendants)) {
			this.gardener.stream.once('end', function() {
				var tree = this.gardener.tree
				_.each(this.includeDescendants, function(submetric, id) {
					if (!tree.get(id)) {
						delete this.includeDescendants[id]
					}
				}.bind(this))
				this.model.set('includeDescendants', _.clone(this.includeDescendants))
			}.bind(this))
		}

		this.listenTo(this.formView, 'change', function(e) {
			//determine the correct id the change event is referencing
			var tree = this.gardener.tree
			var id
			if (e && e.target) {
				//user click on the org selection set dropdown
				id = $(e.target).closest('[data-id]').data('id')
			} else {
				var treeItem = tree.selected()
				id = treeItem.id
				//capture the org name, to update the form listing when editing
				let itemLabels = this.model.get('itemLabels') || {}
				itemLabels[id] = treeItem.label
				this.model.set('itemLabels', itemLabels)
			}
			delete this.includeDescendants[id]

			//determine if submetrics are included
			var submetrics = this.$('tr[data-id='+id+'] .cascade input')
			if (submetrics.length) {
				this.includeDescendants[id] = submetrics[0].checked
			}
			this.model.set('includeDescendants', _.clone(this.includeDescendants))
		}.bind(this))
	},

	oldSelections: function() {
		return this.model.get('includeDescendants') || {}
	},

	'delete': function(e) {
		var id = $(e.currentTarget).closest('tr').data('id')
		delete this.includeDescendants[id]
		this.model.set('includeDescendants', _.clone(this.organizationSelections))
		MultiTreeSelector.prototype.delete.apply(this, arguments)
	},

	context: function() {
		return {
			emptyTreeMessage: i18n.get('scorecards.noScorecards'),
			cascadeHelpKey: 'report.metricComparisonReport.includeSubmetrics'
		}
	}

})

export default MetricsView
MetricsView.__filename__ = 'reports/wizard/metric-comparison/metric-comparison-step2.js'
